module.exports = __webpack_public_path__ + "img/img-about-us-77310f66.png";